<script>
import CustomersApi from "@/services/customers-api";
import ReportingApi from "@/services/reporting-api";

export default {
    props: {
      firstDay:{
          type:String,
          default:null
      },
      lastDay:{
          type:String,
          default:null
      },
      isCustomerList :{
          type:Boolean,
          default:false
      },
      isSupplierList:{
          type:Boolean,
          default:false
      }
    },
    data(){
        return{

            customersList:[],
            selectedCustomer:null,
            start:this.firstDay,
            end:this.lastDay,
            loading_sources:false,
            
             pagemodel: {currentPage : 1, perPage :10, totalRows: 0},
             barChart : {}
        }
    },
    methods:{
        getSearchHistory(){


            if(this.isCustomerList){
                ReportingApi.getSearchHistoryChartCustomerList(this.pagemodel.currentPage, this.pagemodel.perPage,this.start,this.end,this.selectedCustomer==null ? null : this.selectedCustomer.id).then(
                     (result) => {
 
                        if(result ){
                             this.loading_sources=false
                             this.renderBarChart()
                            if(result.list){
                                for(const i in result.list){
                                    this.barChart.series[0].data.push(result.list[i].searchesCount)
                                    this.barChart.chartOptions.xaxis.categories.push(result.list[i].customer)
                                }
                                this.pagemodel.totalRows = result.total;
                                this.pagemodel.currentPage = result.page;
                                this.pagemodel.perPage = result.pageSize;
                                this.pagemodel.pageSize = result.pageSize;
                             }
                             this.loading_sources=true
 
                         }
                     }
                 )
            }

            if(this.isSupplierList){
                ReportingApi.getSearchHistoryChartSupplierList(this.pagemodel.currentPage, this.pagemodel.perPage,this.start,this.end,this.selectedCustomer==null ? null : this.selectedCustomer.id).then(
                     (result) => {
                        if(result ){
                             this.loading_sources=false
                             this.renderBarChart()
                            if(result.list){
                                for(const i in result.list){
                                    this.barChart.series[0].data.push(result.list[i].searchesCount)
                                    this.barChart.chartOptions.xaxis.categories.push(result.list[i].customer)
                                }
                                this.pagemodel.totalRows = result.total;
                                this.pagemodel.currentPage = result.page;
                                this.pagemodel.perPage = result.pageSize;
                                this.pagemodel.pageSize = result.pageSize;
                             }
    
                             this.loading_sources=true
 
                         }
                     }
                 )
            }


        },

        renderBarChart(){
            this.barChart=   {
                series: [{
                    data: []
                }],
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: true,
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    dataLabels: {
                        enabled: true,
                    },
                    colors: [this.isCustomerList ? '#b02f17' : '#50a5f1'],
                    grid: {
                        borderColor: '#f1f1f1',
                        
                    },
                    xaxis: {
                        categories: [],
                    },
  
                    tooltip: {
                        enabled:false,
                        y: {
                            formatter: function (val) {
                                return val.toFixed(0)
                            }

                            
                        },
                        
                    }
                }
            }
        },

        getCustomers(){
        CustomersApi.getCustomers(null,null).then(
            response => {
            this.customersList=response;
            }
        )
        },

    },
    mounted(){
        this.getSearchHistory()

        if(this.isSupplierList){
            this.getCustomers()
        }

    },
        watch: {
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getSearchHistory()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getSearchHistory()
          }
        },

        selectedCustomer: function(){
            this.getSearchHistory()
        }
    }
}
</script>

<style>
    

    .apex-charts text {
        font-family: "Poppins", sans-serif !important;
        fill: white !important;
    }

    .apexcharts-yaxis text, .apexcharts-xaxis text {
      font-family: "Poppins", sans-serif !important;
      fill: #333333 !important;
     }

</style>

<template>
    <div class="clearfix m-4" style="min-height:350px">
        <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark">{{ isCustomerList ?  $t("reporting.customer.verticalBarChart") :  $t("reporting.supplier.tabHistory.verticalBarChart") }}</h4>
        <div  class="row mt-4">
            <div v-if="isSupplierList" :class=" isSupplierList ? 'col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2' : 'col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2'    ">
                <b-form-group :label="$t('lists.customers.filter')" label-for="">
                    <v-select class="style-vselect-big" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selectedCustomer">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div>
            <div :class=" isSupplierList ? 'col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2' : 'col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2'">
            <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"   label-for="">
                <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
            <div :class=" isSupplierList ? 'col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12' : 'col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12'">
            <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')"  label-for="">
                <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
        </div>

        <apexchart
            v-if="loading_sources"
            class="apex-charts"
            height="350"
            type="bar"
            dir="ltr"
            :series="barChart.series"
            :options="barChart.chartOptions"
        ></apexchart>

        <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4"  v-if="loading_sources">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getSearchHistory()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,20,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getSearchHistory()" :disabled="!loading_sources" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
 

    </div>
</template>